export default __webpack_public_path__ + "static/media/reminder.a6286a74.svg";